import { render, staticRenderFns } from "./Empleados.vue?vue&type=template&id=42b67956&"
import script from "./Empleados.vue?vue&type=script&lang=js&"
export * from "./Empleados.vue?vue&type=script&lang=js&"
import style0 from "./Empleados.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports